export default "__VITE_ASSET__Dn6yP1gM__"